import { message as $message } from 'antd'
import { fetchOrderCountApi, getOrderQuestion } from '@/services/order'
import { queryUserConfig, addUserConfig } from '@/services/user'

const ORDER_QUSETION_PIN_LIST = 'ORDER_QUSETION_PIN_LIST'

let count = 0

const OrdersNumModel = {
    namespace: 'ordersNum',
    state: {
        ordersNum: null, // 分销订单数量 -> 自发代发合并
        selfOrdersNum: null, // 自发订单数量
        question: {}, // 分销订单异常订单 -> 自发代发合并
        selfQuestion: {}, // 自发订单异常订单
        questionPinList: []
    },
    effects: {
        *query({ payload }, { call, put }) {
            const { orderTypeEnum, noSendHour = 24 } = payload ?? {}
            try {
                count += 1
                const fetchId = count
                const res = yield call(fetchOrderCountApi, {
                    noSendHour, // 默认查24小时的发货快逾期
                    orderTypeEnum: orderTypeEnum || 'ALL'
                })
                if (res.success) {
                    if (fetchId === count) {
                        const ordersNum = res.data
                        const result = { ordersNum }
                        if (res.data) {
                            yield put({
                                type: 'update',
                                payload: result
                            })
                        }
                        return ordersNum
                    }
                } else {
                    $message.error(res.message)
                }
            } catch (e) {
                console.error('catchError', e)
            }
        },
        *queryQuestion({ payload }, { call, put }) {
            const { orderTypeEnum } = payload ?? {}
            try {
                const res = yield call(getOrderQuestion, [orderTypeEnum || 'ALL'])
                if (res.success) {
                    if (res.data) {
                        yield put({
                            type: 'updateQuestion',
                            payload: { question: res.data }
                        })
                        return res.data
                    }
                } else {
                    $message.error(res.message)
                }
            } catch (e) {
                console.error('getOrderQuestion error', e)
            }
        },
        *queryQuestionPinlist({ payload }, { put, call }) {
            // 打单单独传入key
            const configKey = payload?.configKey ?? ORDER_QUSETION_PIN_LIST
            const response = yield call(queryUserConfig, { configKey })
            const { success, data, message } = response ?? {}
            if (!success) {
                $message.error(message)
                return
            }
            if (data && data[configKey]) {
                yield put({
                    type: 'updateQuestionPinList',
                    payload: data[configKey]?.pinList
                })
            }
        },
        *saveQuestionPinList({ payload, configKey }, { put, call }) {
            yield put({
                type: 'updateQuestionPinList',
                payload
            })
            yield call(addUserConfig, {
                configKey: configKey ?? ORDER_QUSETION_PIN_LIST,
                configValue: {
                    pinList: payload
                }
            })
        }
    },
    reducers: {
        updateQuestion(state, { payload }) {
            return {
                ...state,
                ...payload
            }
        },
        update(state, { payload }) {
            return {
                ...state,
                ...payload
            }
        },
        updateQuestionPinList(state, { payload }) {
            return {
                ...state,
                questionPinList: payload
            }
        }
    }
}

export default OrdersNumModel
